export class LoginDTO {

  constructor(
    readonly email: string,
    readonly password: string
  ) {
  }
}